import React from "react";
import { ArrowDownOutlined } from "@ant-design/icons";
import { Row, Col } from "components/common";
import { Wrapper } from "./UserCard.styled";
import UserCardEntity from "./UserCardEntity/UserCardEntity";
import filter from "../../../assets/images/filter.png";

const UserCard = ({ data, handleLoginAsUser, setIsdrawerOpen, setIsSortLoading, pagination, updatePagination }) => {

  const loadMoreRecords = () => {
    if (data.length < parseInt(pagination.total)) {
      setIsSortLoading(false);
      updatePagination(0, parseInt(pagination.limit) + 10)
    };
  }

  return (
    <Wrapper>
      <Row>
        <Col span={24} className="filter">
          <img
            src={filter}
            className="pointer"
            onClick={() => {
              setIsdrawerOpen(true);
            }}
            alt=""
          />
        </Col>
      </Row>
      <Row gutter={[15, 30]}>
        {data.map((item) => {
          return (
            <Col xs={24} md={12}>
              <UserCardEntity
                data={item}
                handleLoginAsUser={handleLoginAsUser}
              />
            </Col>
          );
        })}
      </Row>
      {data.length < parseInt(pagination.total) && (
        <div className="scroll-button-container">
          <button className="scroll-button" onClick={loadMoreRecords}>
            <ArrowDownOutlined style={{ color: 'white', fontSize: 20 }} />
          </button>
        </div>
      )}
    </Wrapper>
  );
};

export default UserCard;
